module.exports = __webpack_public_path__ + "static/media/peripherothon_1.0.33e65370.pdf";